<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="users"
    :search="search"
    v-model="selected"
    show-select
    dense
    :items-per-page="-1"
    sort-by="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>DISPARO EMAIL BOAS VINDAS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="green darken-1"
          dark
          @click="handleSendEmail()"
        >
          <v-icon left>mdi-send</v-icon>
          Disparar Emails
        </v-btn>
        <v-dialog v-model="dialogShowEmail" max-width="800px">
          <v-card>
            <v-toolbar color="blue lighten-1" dark class="text-h5"
              >Visualizar Email</v-toolbar
            >
            <v-card-text>
              <iframe
                :src="`${url}${idShowEmail}`"
                frameborder="0"
                width="100%"
                height="600"
              ></iframe>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeShowDelete()"
                >Fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      {{ getLabel(item.status) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status_shoot="{ item }">
      <v-chip label :color="getColorStatusShoot(item.status_shoot)" dark>
        {{ getLabelShootStatus(item.status_shoot, item.sent_in) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.type="{ item }">
      <v-chip label :color="getColorType(item.type)" dark>
        {{ getLabelType(item.type) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-if="!loading" v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="sendIndividualEmail(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-send
          </v-icon>
        </template>
        <span>Disparo Individual</span>
      </v-tooltip>
      <v-tooltip top color="green">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="green darken-1"
            @click="showEmail(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-email
          </v-icon>
        </template>
        <span>Visualizar Email</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL } from "@/api/config";
import * as API from "@/api/requests/UserRequest";
import { USER_TYPES_DESCRIPTION } from "@/api/constants";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    selected: [],
    loading: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        width: 50,
      },
      { text: "Nome", value: "name", width: 200 },
      { text: "Email", value: "email", width: 200 },
      { text: "Tipo", value: "type", width: 100 },
      { text: "Status", value: "status", width: 100 },
      {
        text: "Status Dispardo",
        value: "status_shoot",
        width: 100,
        sortable: false,
      },
      {
        text: "Ações",
        value: "actions",
        align: "right",
        sortable: false,
        width: 100,
      },
    ],
    users: [],
    userTypes: [],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
    shoot_status: [
      {
        text: "Não enviado",
        value: "not_send",
      },
      {
        text: "Enviado",
        value: "send",
      },
      {
        text: "Erro ao Enviar",
        value: "error",
      },
    ],
    url: "",
    idShowEmail: "",
    dialogShowEmail: false,
  }),

  computed: {},

  created() {
    this.userTypes = USER_TYPES_DESCRIPTION;
    this.initialize();
    this.url = `${URL.replace("/api/", "")}/user/hello/`;
    console.log(this.url);
  },

  methods: {
    async initialize() {
      await this.getUsers();
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    getColorType(type) {
      let findType = this.userTypes.find((item) => item.value === type);
      if (findType !== undefined) {
        return findType.color;
      } else {
        return "gray";
      }
    },
    getLabelType(type) {
      let findType = this.userTypes.find((item) => item.value === type);
      if (findType !== undefined) {
        return findType.text;
      } else {
        return "Outros";
      }
    },

    async getUsers() {
      this.loading = true;
      this.users = [];
      try {
        this.users = await API.getAll();
        this.users = this.users.map((item) => ({
          ...item,
          status_shoot: "not_send",
          sent_in: "2024-01-08 10:00:00",
        }));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    getLabelShootStatus(status, sent_in) {
      let sStatus = this.shoot_status.find((item) => item.value === status);
      if (sStatus !== undefined) {
        if (status === "send") {
          return `${sStatus.text} - ${sent_in}`;
        }
        return sStatus.text;
      } else {
        return "";
      }
    },
    getColorStatusShoot(status) {
      if (status === "send") {
        return "green";
      } else if (status === "error") {
        return "red";
      } else {
        return "blue";
      }
    },
    showEmail(item) {
      window.open(`${this.url}${item.id}`, "_blank", "noreferrer");
      // this.idShowEmail = item.id;
      // this.dialogShowEmail = true;
    },
    closeShowDelete() {
      this.idShowEmail = "";
      this.dialogShowEmail = false;
    },
    sendIndividualEmail(item) {
      console.log(item.id);
      this.sendEmail([item]);
    },
    handleSendEmail() {
      if (this.selected.length === 0) {
        alert("Selecione para poder disparar");
        return;
      }
      this.sendEmail(this.selected);
    },
    async sendEmail(data) {
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}user/send-hello-email`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        res = await res.json();
        alert(res.message);
        this.selected = [];
      } catch (error) {
        alert("Não foi possível disparar o email, tente novamente mais tarde");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
